<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'document-confirm'"
    @hidden="$emit('onCloseModal')"
    style="margin-bottom: unset;"
    @show="() => {}"
  >
    <b-form @submit.prevent="$emit('onSubmit')">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header">
            {{ `Confirm ${titleModal}` }}
          </div>
        </div>
      </div>
      <div class="modal-wrp mx-3">
        <div class="row mb-1 overflow-dialog">
          <div class="col-12">
            <b-row
              v-for="(field, index) in formDataObj.information.payload"
              :key="`row-${field.key + index}`"
              :class="index > 0 ? 'mt-1' : null"
            >
              <b-col cols="12" v-if="field.type_id == 19">
                <label
                  :for="`input-${field.key}`"
                  class="style-hander"
                  :class="field.required ? 'required' : null"
                  style="font-size: 20px;"
                >
                  {{ $i18n.locale == "th" ? field.label_th : field.label_en }}
                </label>
                <v-select
                  v-model="field.optionid"
                  class="select-format-container font-medium-5 bg-dropdown"
                  :options="field.opt_fields"
                  :reduce="(option) => option.value"
                  :clearable="false"
                  :placeholder="'Please Select'"
                  :disabled="true"
                />
              </b-col>
              <b-col
                cols="12"
                v-else-if="field.type_id != 20 && field.type_id != 21"
              >
                <component
                  :is="resolveFields(field)"
                  :ref="`${field.key + index}`"
                  :key="field.key"
                  class="input-disabled"
                  :field-properties="field"
                />
              </b-col>
              <b-col
                cols="12"
                v-if="
                  (field.type_id == 20 || field.type_id == 21) &&
                    field.isdelete == false
                "
              >
                <b-row :class="index > 0 ? 'mt-1' : null">
                  <b-col cols="6">
                    <label
                      :for="`input-${field.key}`"
                      class="style-hander"
                      :class="field.required ? 'required' : null"
                      style="font-size: 20px;"
                    >
                      {{
                        $i18n.locale == "th" ? field.label_th : field.label_en
                      }}
                    </label>
                    <v-select
                      v-model="field.optionid"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :options="field.opt_fields"
                      :reduce="(option) => option.value"
                      :clearable="false"
                      :placeholder="'Please Select'"
                      :disabled="true"
                    />
                  </b-col>
                  <b-col cols="6">
                    <label class="style-hander" style="font-size: 20px;">
                      {{ "Value" }}
                    </label>
                    <b-form-input
                      :ref="`${field.key + index}`"
                      :id="`input-${field.key}`"
                      v-model="field.value"
                      :type="field.type_id == 20 ? 'text' : 'number'"
                      :step="field.type_id == 20 ? '' : '0.01'"
                      placeholder="ระบุ"
                      :disabled="true"
                    />
                  </b-col>
                  <!-- <b-col
                    v-if="
                      dynamicDropdownCondition(field, 'checkcount') > 1 &&
                        !isConfirm
                    "
                    cols="1"
                    class="d-flex align-items-end custom-delete-dropdown"
                  >
                    <b-button
                      class="delete-dropdown"
                      v-b-tooltip.hover
                      @click="onRemoveDropDown(field, index)"
                    >
                      <delete-icon class="svg-delete-icon" />
                    </b-button>
                  </b-col> -->
                </b-row>
                <!-- <b-row
                  v-if="
                    dynamicDropdownCondition(field, 'lastfield') && !isConfirm
                  "
                >
                  <b-col cols="11" class="d-flex justify-content-end">
                    <b-button
                      class="add-dropdown-value"
                      @click="onAddDropDown(field, index)"
                    >
                      <div>
                        <icon-plus class="svg-plus-icon" />
                      </div>
                    </b-button>
                  </b-col>
                </b-row> -->
              </b-col>
            </b-row>

            <!-- <b-row
              v-for="(field, index) in formDataObj.information.payload"
              :key="`row-${field.seq}`"
              :class="index > 0 ? 'mt-1' : null"
            >
              <b-col cols="12">
                <component
                  :is="resolveFields(field)"
                  :ref="`${field.key}`"
                  :key="field.key"
                  class="input-disabled"
                  :field-properties="field"
                />
              </b-col>
            </b-row> -->
            <br />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button class="ml-1" type="submit" />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue"
import Textbox from "@/views/components/dynamic-fields/components/TextBoxField.vue"
import TextAreaField from "@/views/components/dynamic-fields/components/TextAreaField.vue"
import Dropdown from "@/views/components/dynamic-fields/components/DropdownField.vue"
import DatePicker from "@/views/components/dynamic-fields/components/DatePickerField.vue"
import useDocumentConfirmModal from "../hooks/useDocumentConfirmModal"

export default {
  components: {
    Toggle,
    Textbox,
    TextAreaField,
    Dropdown,
    DatePicker,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    formDataObj: { type: Object, default: {} },
  },
  setup(props) {
    const {
      titleModal,
      resolveFields,
      onSubmitModal,
    } = useDocumentConfirmModal(props)

    return {
      titleModal,
      resolveFields,
      onSubmitModal,
    }
  },
}
</script>

<style scoped>
.overflow-dialog {
  overflow-y: scroll;
  max-height: 400px;
}
.overflow-dialog::-webkit-scrollbar {
  -webkit-appearance: none !important;
  width: 7px;
}

.overflow-dialog::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
